<script>
export default {
  name: 'BaseCard',

  props: {
    variant: {
      type: String,
      default: 'default',
      validator: v => ['default', 'compact', 'flat', 'flush'].includes(v),
    },

    tag: {
      type: String,
      default: 'div',
    },
  },

  computed: {
    cardClasses () {
      return {
        [this.$classes['base-card']]: true,
        [this.$classes[this.variant]]: this.variant !== 'default',
      }
    },
  },
}
</script>

<template>
  <component :is="tag" :class="cardClasses">
    <slot />
  </component>
</template>

<style module>
.base-card {
  background-color: #ffffff;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}

.compact {
  padding: 10px 12px;
}

.flat {
  box-shadow: none;
  border: 1px solid #e0e0e0;
}

.flush {
  padding: 0;
}
</style>
